import { Component, OnInit, Optional, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { PaymentMethodComponent } from 'src/app/pos-order/components/payment-method/payment-method.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CROSS } from 'src/defaultImages.js';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';

@Component({
  selector: 'app-voucher-title',
  templateUrl: './voucher-title.component.html',
  styleUrls: ['./voucher-title.component.css'],
})
export class VoucherTitleComponent implements OnInit, OnDestroy {
  images = { 
    CROSS: CROSS,
  };
  codeInputScreen: boolean = false;
  headerTitle: string = 'Voucher Title';
  selectorText: string = 'Select Voucher Title';
  isLoading: boolean = false;
  validateForm: FormGroup;
  modalTexts: any;
  subscription = new Subscription();
  voucherValidity = {
    message: '',
    status: '',
    statusCode: null,
  };
  listOfDiscounts: any = [];
  selectedVoucherTitle: string = '';
  constructor(
    public dialogRef: MatDialogRef<PaymentMethodComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private fb: FormBuilder,
    private translateService: TranslateService,
    private _localStorage: LocalStorageService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
  }

  ngOnInit() {
    this.subscription.add(
      this.translateService.get('POS').subscribe((data: any) => {
        this.modalTexts = { ...data };
        this.headerTitle = this.modalTexts.VOUCHER_TITLE;
        this.selectorText = this.modalTexts.SEL_VOUC_TITLE;
      })
    );
    this.validateForm = this.fb.group({
      code: [null, [Validators.required]],
    });
    this.getAllVoucher();

    this.validateForm.get('code').valueChanges.subscribe((value) => {
      this.voucherValidity.status = null;
      this.voucherValidity.message = '';
      this.voucherValidity.statusCode = null;
      // }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  cancelClicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  onNextClick() {
    this.codeInputScreen = true;
    this.headerTitle = this.modalTexts.VOUC_CODE;
    this.selectorText = this.modalTexts.ENTER_VOUC_CODE;
  }
  onBackClick() {
    this.codeInputScreen = false;
    this.headerTitle = this.modalTexts.VOUCHER_TITLE;
    this.selectorText = this.modalTexts.SEL_VOUC_TITLE;
  }

  getVoucherPayload() {
    if ((this.data || {}).isFoodcourt) {
      return {
        payload: {
          kiosk_restaurant_id: this._localStorage.get('restaurant_id'),
          fc_order_id: (this.data || {}).fc_order_id,
          code: this.validateForm.value.code,
          title: this.selectedVoucherTitle,
          token: this._localStorage.get('token'),
        },
        api: 'applyThirdPartyVoucherFoodcourt',
      };
    }

    return {
      payload: {
        restaurant_id: this._localStorage.get('restaurant_id'),
        order_id: this.data.order_id,
        code: this.validateForm.value.code,
        title: this.selectedVoucherTitle,
        token: this._localStorage.get('token'),
      },
      api: 'applyThirdPartyVoucher',
    };
  }

  onApplyClicked() {
    this.voucherValidity.status = '';
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
    if (this.validateForm.valid) {
      const voucherPayload = this.getVoucherPayload();
      this.isLoading = true;
      this.voucherValidity.status = 'validating';
      this.apiService[voucherPayload.api](voucherPayload.payload).subscribe(
        (response: any) => {
          this.isLoading = false;
          this.voucherValidity.message = (response.data || {}).message;
          this.voucherValidity.statusCode = response.statusCode;
          this.voucherValidity.status = 'success';
          setTimeout((_) => {
            this.dialogRef.close({
              data: response.data,
              success: 1,
              message: 'voucher_applied',
            });
          }, 500);
        },
        (error) => {
          this.isLoading = false;
          this.voucherValidity.message = (error.error || {}).message;
          this.voucherValidity.statusCode = (error.error || {}).statusCode;
          this.voucherValidity.status = 'error';
        }
      );
    }
  }
  getAllVoucher() {
    let rest_id = localStorage.getItem('restaurant_id');
    this.apiService
      .getAllVouchers(localStorage.getItem('hq_id'), rest_id)
      .subscribe(
        (response) => {
          if ((response || {}).statusCode === 200) {
            this.listOfDiscounts = (response || {}).data;
          } else {
            this.listOfDiscounts = [];
          }
        },
        (error) => {
          this.listOfDiscounts = [];
        }
      );
  }
  voucherTitleClicked(e) {
    this.selectedVoucherTitle = e;
  }
}
